var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contents"},[_c('div',{staticClass:"box-view-wrap"},[_c('search-result',{ref:"searchResult",attrs:{"grid-props":_vm.getGridProps(this.rendererEventCallback)}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }